import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export type SummaryBarItem = {
  label: ReactNode;
  value: ReactNode;
};

export type SummaryBarProps = HTMLAttributes<HTMLDivElement> & {
  items?: SummaryBarItem[];
  totalLabel: ReactNode;
  totalValue: ReactNode;
  note?: ReactNode;
};

export const SummaryBar = forwardRef<HTMLDivElement, SummaryBarProps>(({ className, items = [], totalLabel, totalValue, note, ...props }, ref) => (
  <div ref={ref} className={cn("bfrs-rounded-xl bfrs-border bfrs-border-border bfrs-bg-primary-soft bfrs-px-4 bfrs-py-3", className)} {...props}>
    <div className="bfrs-flex bfrs-flex-wrap bfrs-items-center bfrs-gap-x-5 bfrs-gap-y-2">
      {items.map((item, index) => (
        <div key={index} className="bfrs-flex bfrs-items-center bfrs-gap-1.5 bfrs-text-xs bfrs-text-text-secondary">
          <span>{item.label}</span>
          <span className="bfrs-font-semibold bfrs-text-text-primary">{item.value}</span>
        </div>
      ))}
      <div className="bfrs-ml-auto bfrs-flex bfrs-items-baseline bfrs-gap-2">
        <span className="bfrs-text-xs bfrs-font-semibold bfrs-text-text-secondary">{totalLabel}</span>
        <span className="bfrs-text-base bfrs-font-bold bfrs-text-text-primary">{totalValue}</span>
      </div>
    </div>
    {note && <div className="bfrs-mt-1 bfrs-text-xs bfrs-text-text-muted">{note}</div>}
  </div>
));

SummaryBar.displayName = "SummaryBar";
